import { isPreviewing, isEditing } from "@builder.io/sdk-vue";

export function useBuilderShowIf() {
    const hasValue = (fieldName: string) => {
        return `
            let value = options.get('${fieldName}') ?? '';
            return !!value;
        `;
    };

    const hasValueEqualTo = (fieldName: string, value: string | number) => {
        //split fieldName by '.' to get the nested field
        const nestedFields = fieldName.split('.');
        if (nestedFields.length > 1) {
            const nestedField = nestedFields[1];
            return `
                let value = options.get('${nestedFields[0]}')['${nestedField}'] ?? '';
                return value == '${value}';
            `;
        }
        return `
            let value = options.get('${fieldName}') ?? '';
            return value == '${value}';
        `;
    };
    const hasRichText = (fieldName: string) => {
        return `
            if (typeof window === 'undefined') return false;
            const parser = new DOMParser();
            const htmlString = options.get('${fieldName}') ?? '';
            const doc = parser.parseFromString(htmlString, 'text/html');
            const body = doc.body;
            const textContent = body?.textContent?.trim();
            return !!textContent;
        `;
    };

    const isVideo = (fieldName: string) => {
        return `
            let value = (options.get('${fieldName}') ?? '');
            return value && !value.includes("/image/");
        `;
    };

    return {
        hasValue,
        hasValueEqualTo,
        hasRichText,
        getPlainText,
        isVideo
    };
}

export function useRichTextFormatting(text: string) {
    const $ = cheerio.load(text ?? '');
    const childNodes = $('body')?.[0]?.childNodes;
    const valid = childNodes.filter((node) => node.type === 'tag').length > 0 ? text === $('body').html() : true;

    if(valid && childNodes.length == 1 && childNodes?.[0]?.tagName === 'p'){
        return $(childNodes?.[0]).html();
    }
    else if(!valid && isEditing()){
        return text + "<br/><strong>Contains Invalid HTML which may render improperly.<br/>This message will not appear on the live site.</strong>";
    }
    
    return text;
}

export function richTextHasText(text: string) {
    if (!text) return false;
    const textOnly = text.replace(/<[^>]*>/g, "");
    return textOnly?.trim().length > 0;
}

export function getPlainText(text: string) {
    if (!text) return false;
    const textOnly = text.replace(/<[^>]*>/g, "");
    return textOnly?.trim();
}